import { useTranslation } from "react-i18next";

const ForSchools = () => {
    const { t } = useTranslation();

    const features = [
        {
            title: t("forSchools.feature1.title"),
            description: t("forSchools.feature1.description"),
            image: "https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/school-teacher-talking.svg",
        },
        {
            title: t("forSchools.feature2.title"),
            description: t("forSchools.feature2.description"),
            image: "https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/safe-data.svg",
        },
        {
            title: t("forSchools.feature3.title"),
            description: t("forSchools.feature3.description"),
            image: "https://aussprachetrainer-ci-cd.s3.eu-central-1.amazonaws.com/public/happy-students.svg",
        },
    ];

    return (
        <div className="bg-white min-h-screen">
            <div className="max-w-6xl mx-auto px-4 py-16">
                {/* Hero Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-bold mb-6">{t("forSchools.hero.title")}</h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                        {t("forSchools.hero.subtitle")}
                    </p>
                </div>

                {/* Features Section */}
                <div className="space-y-8 mb-16">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className={`flex flex-col ${
                                index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                            } items-center gap-8 md:gap-12`}
                        >
                            <div className="w-full md:w-1/2 flex justify-center">
                                <img
                                    src={feature.image}
                                    alt={feature.title}
                                    className="w-full max-w-md h-auto"
                                />
                            </div>

                            <div className="w-full md:w-1/2">
                                <h2 className="text-3xl font-bold mb-4 text-gray-900">
                                    {feature.title}
                                </h2>
                                <p className="text-lg text-gray-700 leading-relaxed">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="border-primary border rounded-2xl p-12 text-center">
                    <h2 className="text-3xl font-bold mb-4 text-gray-900">
                        {t("forSchools.cta.title")}
                    </h2>
                    <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
                        {t("forSchools.cta.subtitle")}
                    </p>
                    <a
                        href={`mailto:kontakt@aussprachetrainer.org?subject=${encodeURIComponent(
                            t("forSchools.cta.emailSubject")
                        )}`}
                        className="inline-block bg-primary hover:bg-purple-600 text-white font-semibold px-8 py-4 rounded-lg"
                    >
                        {t("forSchools.cta.button")}
                    </a>
                </div>

                {/* Social Proof Section */}
                <div className="mt-16 text-center">
                    <p className="text-gray-600 text-xs md:text-sm italic">
                        {t("forSchools.socialProof")}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ForSchools;
